import { Stack, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CustomChip } from 'src/shared/components/organisms/customChip';
import { GroupMessageSmsStatusesEnum } from '../models/groupMessageSmsStatusesEnum';

type GroupMessageSmsStatusesProps = {
  status?: GroupMessageSmsStatusesEnum;
  chipSize: 'small' | 'medium' | undefined;
};

export const GroupMessageSmsStatuses = (props: GroupMessageSmsStatusesProps) => {
  const { status = undefined, chipSize } = props;
  const { t } = useTranslation(['groupMessage']);

  return (
    <Stack direction='row' spacing={1} sx={{ '& .MuiChip-filled ': { borderRadius: 1 } }}>
      {status === GroupMessageSmsStatusesEnum.Sent && (
        <Tooltip describeChild title={t('groupMessage:sms.status.sent')} arrow>
          <CustomChip label={t('groupMessage:sms.status.sent')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {status === GroupMessageSmsStatusesEnum.Delivered && (
        <Tooltip describeChild title={t('groupMessage:sms.status.delivered')} arrow>
          <CustomChip label={t('groupMessage:sms.status.delivered')} color='success' size={chipSize} />
        </Tooltip>
      )}
      {status === GroupMessageSmsStatusesEnum.NotSent && (
        <Tooltip describeChild title={t('groupMessage:sms.status.notSent')} arrow>
          <CustomChip label={t('groupMessage:sms.status.notSent')} color='warning' size={chipSize} />
        </Tooltip>
      )}
      {status === GroupMessageSmsStatusesEnum.Failed && (
        <Tooltip describeChild title={t('groupMessage:sms.status.failed')} arrow>
          <CustomChip label={t('groupMessage:sms.status.failed')} color='error' size={chipSize} />
        </Tooltip>
      )}
    </Stack>
  );
};
